import { styled } from '@vebox/etui-system';
import { mediaMax } from './utilities/responsive.js';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from './_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import { fade } from '@vebox/etui-colors';
import { format } from 'date-fns';

const _excluded = ["top", "left", "theme"];
const GridSlotGroupDiv = styled(Div)`
  position: relative;
  border-bottom: 1px solid ${({
  theme
}) => theme.palette.divider};
  min-height: 25px;
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;

  ${({
  theme
}) => mediaMax(theme).xs`
    min-height: 20px
  `};
`;
const GridSlotDiv = styled(Div)`
  flex: 1 1 auto;
  line-height: 0.75;
`;
const GridSlotValueSpan = styled(Span)`
  color: ${({
  theme
}) => theme.palette.text.disabled};
  font-size: ${({
  theme
}) => theme.typography.fontSizeSmall};
  text-transform: lowercase;
`;
const GridSlotTooltip = styled(Span).attrs(_ref => {
  let {
      top,
      left,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'fixed',
    zIndex: 9999,
    style: {
      borderBottom: `2px solid ${fade(theme.palette.text.secondary, theme.palette.tonalOffset)}`,
      color: theme.palette.text.secondary,
      left,
      top,
      pointerEvents: 'none',
      fontSize: theme.typography.fontSizeBase
    }
  }, props);
})``;

const GridSlotGroup = props => {
  const renderTimeSlot = (_, index) => {
    if (index !== 0) return null;
    const firstValue = props.group[0];
    const value = format(firstValue, props.timeFormat).replace(':00', '');
    return /*#__PURE__*/createElement(GridSlotValueSpan, null, value);
  };
  const handleSlotMouseEnter = (e, timeValue) => {
    if (props.onGridSlotMouseEnter) {
      props.onGridSlotMouseEnter(e, timeValue);
    }
  };
  const {
    group,
    isColumn = false
  } = props;
  return /*#__PURE__*/createElement(GridSlotGroupDiv, null, group.map((value, index) => {
    return /*#__PURE__*/createElement(GridSlotDiv, {
      key: index,
      onMouseMove: e => handleSlotMouseEnter(e, value)
    }, !isColumn && renderTimeSlot(value, index));
  }));
};

export { GridSlotTooltip as G, GridSlotGroup as a };
